import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PROJECT_UPDATE',
    smsDelete : 'PROJECT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        rfp_category: [],
        rfp: [],
        rfp_by_category:[],
        rfp_by_search:[],
        count:null,
        rfp_detail: {},
        rfp_label_list:[],
        rfp_submitted_list:[],
        rfp_form_response:[],
        rfp_submission_response:{},
        form:[],
        rfp_response_reply:[],
        responses:[],
 

        submitLoading: false,
        submitError: false,
        submitSuccess: false,
        

        ...store
    },
    mutations : {
        ...mutations,

        SET_RFP_SUBMITTED_FORM_RESPONSE (state, response) {
            state.rfp_form_response = response;
        },

        SET_RFP_SUBMISSION_DETAILS(state, details) {
            state.rfp_submission_response = details;
        },

        SET_RFP_CATEGORY (state, rfp_category) {
            state.rfp_category = rfp_category;
        },
        
        SET_RFP_LABELS (state, label) {
            state.rfp_label_list = label;
        },
        SET_RFP_FORM_SUBMITTED (state, {results,pg_count}) {
            state.rfp_submitted_list = results;
            state.form_submitted_count = pg_count;
        },

        SET_RFP_RESPONSE_REPLY(state, reply) {
            state.rfp_response_reply = reply;
        },

        SET_RFP (state, {results, pg_count}) {
            state.rfp = results;
            state.count = pg_count;
        },

        SET_RFP_BY_CATEGORY(state, rfpbyCat) {
            state.rfp_by_category = rfpbyCat;
        },

        SET_RFP_BY_SEARCH(state, rfpSearch) {
            state.rfp_by_search = rfpSearch;
        },

        SET_RFP_DETAILS (state, rfp) {
            state.rfp_detail = rfp;
        },

        SET_RFP_FORM (state, item) {
            state.form = item;
        },

        SET_RFP_FORM_RESPONSES (state, item) {
            state.responses = item;
        },




        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async deleterfpFormResonse ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_rfp_form_responses +payload.response_id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchFormResponses',payload.rfp_id);
            return response
        },

        async fetchFormResponses ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_form_responses + payload, config);
                let response = result.data
                commit('SET_RFP_FORM_RESPONSES', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },


        async submitForm ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.submit_rfp_form, {
                    form_data: payload.form_data,
                    submitted_form: payload.form
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchForm', payload.rfp)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addForm ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_rfp_form, payload, config).then(result=>{
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchForm', payload.rfp)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchForm ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_form + payload, config);
                let response = result.data

                commit('SET_RFP_FORM', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        async updateRFP ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try{
                let data= new FormData()
                let payloadData = buildFormData(data, payload.rfp);

                if(payload.vendors !== null) {
                    payload.vendors.forEach((item) => data.append("vendor_id", item))
                } else {
                    // data.append("vendor_id", null)
                }

                let response = await axios.patch(V1API.edit_rfp + payload.id, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRFP')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async deleteRFP ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_rfp + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch('fetchRFP',{currentPage:payload.page, perPage:payload.perPage, start_date:payload.start_date, end_date:payload.end_date, search_term:payload.search_term, status:payload.status, category:payload.category, active:payload.active});
            
            return response
        },

        async fetchRFPDetails ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_details + payload);
                let response = result.data

                commit('SET_RFP_DETAILS', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        async fetchRFP ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };  

            try{
                let params = new URLSearchParams();
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.category) params.append('category', payload.category);
                if (payload.active) params.append('active', payload.active);
               
                let url = V1API.get_rfp + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_RFP', {results, pg_count});
                return result;

            } catch(error) {
                commit('SUBMIT_ERROR', true); 
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchRFPbyCategory ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_list_by_category+payload);
                let response = result.data

                commit('SET_RFP_BY_CATEGORY', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        async fetchRFPbySearch({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_by_search+'?q='+payload);
                let response = result.data

                commit('SET_RFP_BY_SEARCH', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },
 
        async fetchRFPLabels ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.rfp_submission_label_list, config);
                let response = result.data
                commit('SET_RFP_LABELS', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },   

        async addRFP ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try{
                let data= new FormData()
                let payloadData = buildFormData(data, payload.rfp);

                if(payload.vendors !== null) {
                    payload.vendors.forEach((item) => data.append("vendor_id", item))
                } else {
                    // data.append("vendor_id", null)
                }

                // console.log(payloadData)
                let response = await axios.post(V1API.create_rfp, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRFP')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addRFPCategory ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_rfp_category, payload, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRFPCategory')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchRFPCategory ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_rfp_category);
                let response = result.data

                commit('SET_RFP_CATEGORY', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        async deleteRFPCategory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_rfp_category + payload, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchRFPCategory')
            return response
        },

        async toggleRFPStatus ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
           
            let response = await axios.get(V1API.rfp_active_status_toggle + payload.id, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch('fetchRFP', {currentPage:payload.page, perPage:payload.perPage, start_date:payload.start_date, end_date:payload.end_date, search_term:payload.search_term, status:payload.status, category:payload.category, active:payload.active});
            return response
        },

        async updateRfpStatus({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.get(V1API.update_rfp_status+ payload.id + "/" + payload.status_for_change, config).then(result => {
                    let data = result.data
                    return data
                }) 

                dispatch("fetchRFP", {currentPage:payload.page, perPage:payload.perPage, start_date:payload.start_date, end_date:payload.end_date, search_term:payload.search_term, status:payload.status, category:payload.category, active:payload.active})
                return response

            } catch (e) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addRFPLabel({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.rfp_submission_label_add, {
                    name: payload
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRFPLabels')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async deleteRFPLabel ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.rfp_submission_label_delete + payload, config).then(result=>{
                let data = result.data
                return data
            })
          
            dispatch ('fetchRFPLabels')
            return response
        },

        async addLabelToResponse({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.rfp_submission_add_label+payload.response_id, {
                    label_id: payload.label_id
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchFormResponses',payload.form_response)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async deleteLabelFromResponse({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.rfp_submission_delete_label+payload.response_id, {
                    label_id: payload.label_id
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchFormResponses',payload.form_response)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        // Fetch submitted rfp list form_sumitted
        async fetchRFPFormSubmittedList ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.rfp_list_user_submitted_form_only+'?count='+payload.perPage+'&page='+payload.currentPage, config);
                const {results,pg_count} = result.data

                commit('SET_RFP_FORM_SUBMITTED', {results,pg_count});
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },


        async fetchRFPResponseByForm ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.rfp_response_by_form + payload, config);
                let response = result.data

                commit('SET_RFP_SUBMITTED_FORM_RESPONSE', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        async fetchRFPSubmissionDetails ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.rfp_submission_details + payload, config);
                let response = result.data

                commit('SET_RFP_SUBMISSION_DETAILS', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        },

        // RFP Submission Reply
        async addRFPResponseReply ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.rfp_submission_reply_create, {
                    submission: payload.submission,
                    reply:payload.reply,
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                dispatch('fetchRFPResponseReply',payload.submission)
                commit('SUBMIT_SUCCESS', true);  
                return response

            }catch (e) {
                commit('ASSET_ERROR', true);
            }finally {
                commit('ASSET_LOADING', false);
            }
        },

        async fetchRFPResponseReply ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
            try{
                let result = await axios.get(V1API.get_rfp_submission_reply + payload, config);
                let response = result.data
                commit('SET_RFP_RESPONSE_REPLY', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            commit('SUBMIT_LOADING', false);
        }
    },

    

    getters: {}
}
